import { all } from 'redux-saga/effects'
import provinceSagas from './province/saga'
import authSagas from './auth/saga'
import registeremailSagas from './registeremail/saga'
import forgotSagas from './forgot/saga'
import memberSagas from './member/saga'
import programSagas from './program/saga'
import settingSagas from './settings/saga'

export default function* rootSaga(getState) {
  yield all([
    authSagas(),
    registeremailSagas(),
    forgotSagas(),
    provinceSagas(),
    memberSagas(),
    programSagas(),
    settingSagas()
  ])
}
